var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.95,
    height: 18.928,
    viewBox: "0 0 26.95 18.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube_1_",
    "data-name": "youtube (1)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9517",
    "data-name": "Path 9517",
    d: "M34.017,28.008c-2.471-1.321-4.837-2.535-7.256-3.8v7.583c2.545-1.384,5.228-2.651,7.266-3.781Z",
    transform: "translate(-16.064 -18.82)",
    fill: "#5f8e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9518",
    "data-name": "Path 9518",
    d: "M34.017,28.008c-2.471-1.321-7.256-3.8-7.256-3.8l6.379,4.288Z",
    transform: "translate(-16.064 -18.82)",
    fill: "#5f8e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9519",
    "data-name": "Path 9519",
    d: "M16.53,32.338c-5.133-.094-6.886-.18-7.963-.4a3.5,3.5,0,0,1-1.827-.95,3.846,3.846,0,0,1-.866-1.669,10.916,10.916,0,0,1-.37-2.45,58.2,58.2,0,0,1,0-7.942c.165-1.467.245-3.209,1.341-4.225a3.6,3.6,0,0,1,1.8-.908,99.15,99.15,0,0,1,10.213-.359,99.332,99.332,0,0,1,10.213.359,3.513,3.513,0,0,1,2.1,1.246c1,1.573,1.018,3.529,1.119,5.059.042.729.042,4.869,0,5.6a12.792,12.792,0,0,1-.644,4.161,3.067,3.067,0,0,1-.74,1.183,3.543,3.543,0,0,1-1.88.961C24.582,32.334,20.81,32.407,16.53,32.338Zm6.8-9.716c-2.471-1.321-4.837-2.545-7.256-3.813v7.583c2.545-1.384,5.228-2.651,7.266-3.781Z",
    transform: "translate(-5.368 -13.434)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.421085cf02ab6e002c9915e803efd04f.svg";
export { ForwardRef as ReactComponent };